import Avatar from '@/components/avatar'
import { IUser } from '@giphy/js-types'

interface DerankedAvatarOverlayProps {
    user: IUser
    derankTag: { tag: string } | null
    size?: number
}

const getDerankColor = (tag: string) => {
    if (tag === 'giphyderankofficialaccountlow' || tag === 'giphyderankpromotionalaccountlow') {
        return { border: '#fde047', background: 'rgba(253,224,71,0.85)', text: '#000' }
    }
    if (tag === 'giphyderankofficialaccounthigh' || tag === 'giphyderankpromotionalaccounthigh') {
        return { border: '#ef4444', background: 'rgba(239,68,68,0.85)', text: '#fff' }
    }
    return { border: 'transparent', background: 'transparent', text: 'transparent' }
}

const DerankedAvatarOverlay = ({ user, derankTag, size = 208 }: DerankedAvatarOverlayProps) => {
    if (!derankTag) return <Avatar user={user} size={size} />
    const { border, background, text } = getDerankColor(derankTag.tag)
    return (
        <div
            style={{
                position: 'relative',
                border: `3px solid ${border}`,
                display: 'inline-block',
                borderRadius: 0,
            }}
        >
            <Avatar user={user} size={size} />
            <span
                style={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    background,
                    color: text,
                    fontSize: 12,
                    fontWeight: 600,
                    padding: '2px 8px',
                    borderRadius: 0,
                }}
            >
                deranked
            </span>
        </div>
    )
}

export default DerankedAvatarOverlay
